import { Card, Badge } from 'react-bootstrap';
import { Clock } from 'lucide-react';
import { useLanguage } from '../../contexts/LanguageContext';

export const TrainingCard = ({ 
  icon: Icon, 
  title, 
  description, 
  duration,
  onKnowMore 
}) => {
  const { t, language } = useLanguage();

  return (
    <Card className="gov-card training-card h-100">
      <Card.Body className="d-flex flex-column p-4">

        {/* Icon + Duration */}
        <div className="d-flex align-items-start justify-content-between mb-3">
          <div className="service-icon-box" style={{ marginBottom: 0 }}>
            <Icon size={24} />
          </div>

          {duration && (
            <Badge 
              bg="light" 
              text="dark"
              className="d-flex align-items-center gap-1"
              style={{ 
                fontSize: '0.75rem',
                fontWeight: '500',
                padding: '0.375rem 0.625rem',
                border: '1px solid hsl(var(--border))'
              }}
            >
              <Clock size={12} />
              {duration} {t('training.days')}
            </Badge>
          )}
        </div>
        
        {/* Title */}
        <h3 style={{ 
          fontSize: '1.125rem', 
          fontWeight: '600', 
          marginBottom: '0.75rem',
          color: 'hsl(var(--foreground))'
        }}>
          {title}
        </h3>
        
        {/* Description */}
        <p style={{ 
          fontSize: '0.875rem', 
          color: 'hsl(var(--muted-foreground))',
          flex: 1,
          marginBottom: '1rem'
        }}>
          {description}
        </p>
        
        {/* Know More Button */}
        <button 
          className="btn btn-gov-outline btn-sm w-100 mt-auto"
          onClick={() => onKnowMore && onKnowMore(title)}
        >
          {t('training.knowMore')}
        </button>

      </Card.Body>
    </Card>
  );
};